__turbopack_context__.v({
  "Content": "footer-module-scss-module__a5YvrG__Content",
  "mailLink": "footer-module-scss-module__a5YvrG__mailLink",
});
